import React from 'react';
import { usePWAInstall } from 'hooks/usePwaInstall';
import { InstallModal } from 'pages/InstallPrompt';

/**
 * Drops into your App root. It decides whether to show the install modal.
 */
export const PWAGate: React.FC = () => {
	const { shouldNudge } = usePWAInstall();
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		if (shouldNudge) setOpen(true);
	}, [shouldNudge]);

	return <InstallModal open={open} onClose={() => setOpen(false)} />;
};
